module.exports = __webpack_public_path__ + "img/up.be5030ca.webp";